import React, { useState, useEffect } from 'react';
import tw from 'twin.macro';
import { Link } from 'react-router-dom';

const BannerContainer = tw.div`fixed bottom-0 left-0 w-full bg-gray-900 text-white p-4 pb-24 md:p-6 md:pr-24 z-50 flex flex-col md:flex-row items-center justify-between shadow-2xl`;
const TextContent = tw.div`flex-1 mr-0 md:mr-8 mb-4 md:mb-0 text-sm md:text-base leading-relaxed`;
const ButtonsContainer = tw.div`flex gap-4 flex-shrink-0`;
const AcceptButton = tw.button`bg-green-500 hover:bg-green-600 text-white font-bold py-2 px-6 rounded transition duration-200`;
const LearnMoreLink = tw(Link)`bg-transparent border border-white hover:bg-white hover:text-gray-900 text-white font-bold py-2 px-6 rounded transition duration-200`;

export default function CookieConsent() {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const consent = localStorage.getItem('cookieConsentAccepted');
        if (!consent) {
            setIsVisible(true);
        }
    }, []);

    const handleAccept = () => {
        localStorage.setItem('cookieConsentAccepted', 'true');
        setIsVisible(false);
    };

    if (!isVisible) return null;

    return (
        <BannerContainer style={{ zIndex: 9999 }}>
            <TextContent>
                We use cookies to enhance your browsing experience, serve personalized ads or content, and analyze our traffic. 
                By clicking "Accept", you consent to our use of cookies.
            </TextContent>
            <ButtonsContainer>
                <LearnMoreLink to="/privacy">Learn More</LearnMoreLink>
                <AcceptButton onClick={handleAccept}>Accept</AcceptButton>
            </ButtonsContainer>
        </BannerContainer>
    );
}
